import React from 'react';

import type { DateTimeProviderProps } from '@rtkwlf/fenrir-react';
import { DateTimeProvider, ToastProvider } from '@rtkwlf/fenrir-react';

import { FeatureFlags } from '@packages/platform/feature-flags/FeatureFlags';

interface ThemeChildrenProps {
  defaultTimezone?: DateTimeProviderProps['defaultTimezone'];
  /** This fallback component must not be suspendable itself. * For instance, it must not depend on `useTranslation`. */
  fallback: React.ReactNode;
}

export const ThemedChildren = ({
  children,
  defaultTimezone,
  fallback,
}: React.PropsWithChildren<ThemeChildrenProps>) => {
  return (
    <React.Suspense fallback={fallback}>
      <FeatureFlags>
        <DateTimeProvider defaultTimezone={defaultTimezone}>
          <ToastProvider>{children}</ToastProvider>
        </DateTimeProvider>
      </FeatureFlags>
    </React.Suspense>
  );
};
